export * from './fetches';
export * from './check-egyptian-period';
export * from './model';

const LONGEST_TITLE_VARIABLE = 'smallest';
const LONG_TITLE_VARIABLE = 'small';
const NORMAL_TITLE_VARIABLE = 'normal';

//custom title class based on word count
export const getTitleFontSize = (title?: string): string => {
	const wordCount = title?.split(' ')?.length || 0;

	if (wordCount >= 34) return 'smallest';
	if (wordCount > 20) return 'small';
	return 'normal';
};

//TODO we probably will remove this logic in favor of something VH based.
//custom label class based on title size
export const getLabelMaxLines = (titleSize) => {
	switch (titleSize) {
		case LONGEST_TITLE_VARIABLE:
			return 6;
		case LONG_TITLE_VARIABLE:
			return 8;
		case NORMAL_TITLE_VARIABLE:
		default:
			return 10;
	}
};
